// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2196":"de75c03b","2453":"de75c03b","3653":"e528f48d","4320":"d430f954","4383":"a18b5c7a","5776":"36ca85d1","6294":"f8b32d97"}[chunkId] + ".chunk.css";
};